import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'

// 引入字体图标库
import './assets/icon/iconfont.css'

// 根节点font-size计算
import './common/rem'

// 引入elementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入eventBus
import bus from './common/utils/bus'

// 全局样式
import './assets/css/main.scss'
// 引入AES加密
import AES from './common/aes'
Vue.prototype.$aesKey = AES.initAes('4e8759c58fdb413dcc2c243eebab91f6', 9)
Vue.prototype.$bus = bus

// 设置element-ui默认属性
Vue.prototype.$ELEMENT = { size: 'normal' }
Vue.use(ElementUI)

/**
 * 路由验证  默认需要登陆状态
 * @param to {route} 下一步路由信息
 * @param from {route} 上一步路由信息
 * @param next {router} 路由对象 默认进入下一步路由信息
 */
router.beforeEach((to, from, next) => {
  next()
})

/**
 * 根据组件名称 异步载入组件
 * 如果需要将所有组件打包一个文件，且同步载入 将 import(`element-ui/lib/${componentPathName}`) 改为 require(`element-ui/lib/${componentPathName}`)
 */
Promise.all(
  [
    'container',
    'header',
    'aside',
    'main',
    'tooltip',
    'breadcrumb',
    'breadcrumb-item',
    'menu',
    'submenu',
    'menu-item-group',
    'menu-item',
    'carousel',
    'carousel-item',
    'button',
    'upload',
    'dialog',
    'popover',
    'card',
    'icon',
    'loading',
    'input',
    'collapse',
    'collapse-item',
    'message',
    'message-box',
    'select',
    'option-group',
    'option',
    'step',
    'steps',
    'radio',
    'radio-group',
    'checkbox',
    'checkbox-group',
    'slider',
    'time-picker',
    'date-picker',
    'pagination',
    'alert',
    'avatar',
    'cascader',
    'image',
    ...['form', 'form-item'],
    ...['row', 'col'],
    ...['table', 'table-column'],
    ...['tabs', 'tab-pane']
  ].map(async componentPathName => ({
    default: (await require(`element-ui/lib/${componentPathName}`)).default,
    componentPathName
  }))
).then(components => {
  // 注册组件
  components.forEach(({ default: component, componentPathName } = {}) => {
    // 组件注册回调配置
    const componentHandles = {
      message: () => {
        Vue.prototype[`$${componentPathName}`] = component
      },
      notification: () => {
        Vue.prototype.$notify = component
      },
      'message-box': () => {
        Vue.prototype.$msgbox = component
        Vue.prototype.$alert = component.alert
        Vue.prototype.$confirm = component.confirm
        Vue.prototype.$prompt = component.prompt
      },
      loading: () => {
        component.directive && Vue.use(component.directive)
        component.service && (Vue.prototype.$loading = component.service)
      },
      // 默认组件注册方法
      default: () => {
        Vue.use(component)
      }
    }

    const {
      [componentPathName]: handle,
      default: defaultHandle
    } = componentHandles
    component && (handle || defaultHandle)()
  })

  Vue.config.productionTip = false

  // 初始化
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
